<template>
  <div class="receipt-index-page">
    <v-toolbar dense flat class="mb-10 receipt-index-toolbar">
      <div class="text-h4 primary--text">ใบเสร็จรับเงิน</div>
      <div class="receipt-search">
        <v-text-field
          class="ml-10"
          v-model="filter.start_with"
          prepend-inner-icon="mdi-magnify"
          label="ค้นหา เลขทะเบียน ชื่อลูกค้า เบอร์โทร"
          outlined
          rounded
          dense
          single-line
          hide-details
          @keyup="getData"
        ></v-text-field>
      </div>

      <v-spacer></v-spacer>
      <div class="receipt-date-filter">
        <DatePicker
          label="วันที่"
          :value="filter.start_date"
          @onChange="
            val => {
              filter.start_date = val;
              getData();
            }
          "
          hideDetails
          outlined
          rounded
          dense
        />
      </div>

      <div class="receipt-date-filter">
        <DatePicker
          label="ถึงวันที่"
          :value="filter.end_date"
          @onChange="
            val => {
              filter.end_date = val;
              getData();
            }
          "
          hideDetails
          outlined
          rounded
          dense
        />
      </div>
      <v-spacer></v-spacer>

      <div class="receipt-status-filter">
        <v-select
          label="สถานะ"
          :items="status"
          item-value="value"
          item-text="text"
          outlined
          rounded
          dense
          hide-details
          v-model="filter.status"
          @change="getData"
        />
      </div>
      <v-btn color="primary" outlined small class="ml-5 receipt-add-button" @click="add()"
        ><v-icon left small>mdi-plus</v-icon> เพิ่มรายการ</v-btn
      >
    </v-toolbar>
    <v-data-table
      class="d-none d-sm-block elevation-2 row-pointer"
      :headers="headers"
      :items="list"
      :loading="loading"
      :loading-text="$table_loading_text"
      :page.sync="filter.page"
      :items-per-page="filter.item_per_page"
      hide-default-footer
      @click:row="edit"
    >
      <template v-slot:[`item.date_of_issue`]="{ item }">
        {{ item.date_of_issue | moment($formatDate) }}
      </template>
      <template v-slot:[`item.customer_phone_number`]="{ item }">
        <span>{{ phoneNumberFormat(item.customer_phone_number) }}</span>
      </template>
      <template v-slot:[`item.net_price`]="{ item }">
        {{ item.net_price | numeral('0,0.00') }}
      </template>
      <template v-slot:[`item.payment.type`]="{ item }">
        {{ item.payment.type == 1 ? 'โอนผ่าน QR Code' : '' }}
        {{ item.payment.type == 2 ? 'บัตรเครดิต' : '' }}
        {{ item.payment.type == 3 ? 'โอนผ่านเลขบัญชี' : '' }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <menu-ship-receipt
          small
          v-model="item.status"
          :id="item._id"
          :statusId="item.status"
          @success="getData()"
          :docTypeId="docTypeId"
        />
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" color="grey" small outlined rounded>
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <v-list>
            <template>
              <v-list-item dense link @click="print(item)">
                <v-list-item-title>พิมพ์</v-list-item-title>
              </v-list-item>
              <v-list-item dense link @click="edit(item)">
                <v-list-item-title>แก้ไข</v-list-item-title>
              </v-list-item>
              <v-list-item dense link @click="reset(item)">
                <v-list-item-title>ลบ</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>

      <template v-slot:footer>
        <table-pagination-custom
          :page="filter.page"
          :itemsPerPage="filter.item_per_page"
          :length="pageCount"
          @change-page="onChangePage"
          @change-items-per-page="onChangeitemsPerPage"
        />
      </template>
    </v-data-table>

    <div class="hidden-sm-and-up receipt-mobile-list">
      <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-3" />
      <v-card
        v-for="item in list"
        :key="item._id"
        outlined
        class="mb-3 receipt-mobile-card"
        @click="edit(item)"
      >
        <v-card-text class="pa-3">
          <div class="d-flex align-start justify-space-between">
            <div class="pr-2">
              <div class="font-weight-medium">{{ item.customer_name || '-' }}</div>
              <div class="caption grey--text">{{ item.number || '-' }}</div>
            </div>
            <div @click.stop>
              <menu-ship-receipt
                small
                v-model="item.status"
                :id="item._id"
                :statusId="item.status"
                :docTypeId="docTypeId"
                @success="getData()"
              />
            </div>
          </div>
          <v-row dense class="receipt-mobile-details mt-2">
            <v-col cols="6">
              <span>วันที่</span>
              <strong>{{ item.date_of_issue | moment($formatDate) }}</strong>
            </v-col>
            <v-col cols="6" class="text-right">
              <span>ยอดรวมสุทธิ</span>
              <strong class="primary--text">{{ item.net_price | numeral('0,0.00') }}</strong>
            </v-col>
            <v-col cols="6">
              <span>เบอร์โทร</span>
              <strong>{{ phoneNumberFormat(item.customer_phone_number) || '-' }}</strong>
            </v-col>
            <v-col cols="6" class="text-right">
              <span>ช่องทางชำระ</span>
              <strong>{{ paymentTypeText(item.payment && item.payment.type) || '-' }}</strong>
            </v-col>
          </v-row>
          <div class="d-flex justify-end mt-2" @click.stop>
            <v-btn small text color="primary" @click="print(item)">พิมพ์</v-btn>
            <v-btn small text color="primary" @click="edit(item)">แก้ไข</v-btn>
            <v-btn small text color="error" @click="reset(item)">ลบ</v-btn>
          </div>
        </v-card-text>
      </v-card>
      <div v-if="!loading && !list.length" class="text-center grey--text py-8">
        ไม่พบข้อมูลใบเสร็จรับเงิน
      </div>
      <table-pagination-custom
        :page="filter.page"
        :itemsPerPage="filter.item_per_page"
        :length="pageCount"
        @change-page="onChangePage"
        @change-items-per-page="onChangeitemsPerPage"
      />
    </div>
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker.vue';
import * as moment from 'moment';

export default {
  components: {
    DatePicker
  },
  data: () => ({
    bill_id: '',
    _id: '',
    docTypeId: 2,
    loading: true,
    pageCount: 0,
    list: [],
    headers: [
      { text: 'วันที่', value: 'date_of_issue' },
      { text: 'เลขที่เอกสาร', value: 'number', filterable: false },
      { text: 'ชื่อร้าน', value: 'customer_name' },
      { text: 'ชื่อออกใบเสร็จ', value: 'name_for_receipt', filterable: false },
      { text: 'เบอร์โทร', value: 'customer_phone_number', filterable: false },
      { text: 'ยอดรวมสุทธิ', value: 'net_price', filterable: false },
      { text: 'ช่องทาง', value: 'payment.type', filterable: false },
      { text: 'ยอดชำระ', value: 'payment.amount', filterable: false },
      {
        text: 'สถานะ',
        value: 'status',
        sortable: false,
        filterable: false,
        align: 'center'
      },
      { text: 'แก้ไข', value: 'actions', sortable: false, filterable: false }
    ],
    status: [
      { text: 'สถานะ', value: '' },
      { text: 'รอชำระเงิน', value: 0 },
      { text: 'เก็บเงินแล้ว', value: 1 },
      { text: 'ยกเลิก', value: 2 }
    ],
    filter: {
      status: '',
      item_per_page: 20,
      page: 1,
      start_with: '',
      start_date: moment()
        .add(-30, 'days')
        .format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD')
    }
  }),
  created() {
    this.getData();
  },
  methods: {
    add() {
      this.$router.push({ name: 'backoffice-receipt-create' });
    },
    edit(item) {
      this.$router.push({
        name: 'backoffice-receipt-update',
        params: { id: item._id }
      });
    },
    async reset(item) {
      this.$alertConfirm({ title: `ยืนยันลบข้อมูล ?`, text: `` }).then(
        async result => {
          if (result.isConfirmed) {
            let body = {
              token: this.$jwt.sign({ bill_id: item._id }, this.$privateKey, {
                noTimestamp: true
              })
            };
            await this.$axios
              .post(`${this.$baseUrl}/backend/bill/delete_bill`, body)
              .then(res => {
                this.getData(true);
              })
              .catch(err => {
                console.log('err', err);
                this.$alertServerError({ title: err.error_message });
              });
          }
        }
      );
    },
    print(item) {
      this.$router.push({
        name: 'backoffice-receipt-update',
        params: { id: item._id },
        query: { print: true }
      });
    },
    async getData(reload = false) {
      if (reload) {
        this.onChangeitemsPerPage(this.filter.item_per_page);
      }
      this.filter.end_date = moment(this.filter.end_date)
        .set({ hour: 23, minute: 59, second: 59 })
        .format('YYYY-MM-DDTHH:mm:ss');
      this.loading = true;
      let body = {
        token: this.$jwt.sign(this.filter, this.$privateKey, {
          noTimestamp: true
        })
      };
      await this.$axios
        .post(`${this.$baseUrl}/backend/bill/get_bill`, body)
        .then(res => {
          this.list = res.result.data;
          this.pageCount = res.result.total_page || 1;
        })
        .catch(err => {
          console.log('err', err);
          this.$alertServerError({ title: err.error_message });
        });
      this.loading = false;
    },
    onChangePage(page) {
      this.filter.page = page;
      this.getData();
    },
    onChangeitemsPerPage(number) {
      this.filter.item_per_page = number;
      this.onChangePage(1);
    },
    phoneNumberFormat(val) {
      if (val) {
        return val.substring(0, 3) + '-' + val.substring(3, val.length);
      } else return val;
    },
    paymentTypeText(type) {
      if (type === 1) return 'โอนผ่าน QR Code';
      if (type === 2) return 'บัตรเครดิต';
      if (type === 3) return 'โอนผ่านเลขบัญชี';
      return '';
    }
  }
};
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
.receipt-index-page {
  padding: 0 40px;
}
.receipt-search {
  width: 400px;
}
.receipt-date-filter,
.receipt-status-filter {
  width: 200px;
}
@media (max-width: 599px) {
  .receipt-index-page {
    padding: 0 4px;
  }
  .receipt-index-toolbar {
    height: auto !important;
    min-height: 48px;
    margin-bottom: 20px !important;
    padding: 8px 0;
  }
  .receipt-index-toolbar >>> .v-toolbar__content {
    height: auto !important;
    min-height: 32px;
    flex-wrap: wrap;
    gap: 8px;
    padding: 0;
  }
  .receipt-index-toolbar .text-h4 {
    width: 100%;
    font-size: 1.5rem !important;
  }
  .receipt-index-toolbar .v-spacer {
    display: none;
  }
  .receipt-search,
  .receipt-status-filter,
  .receipt-add-button {
    width: 100%;
  }
  .receipt-search .ml-10,
  .receipt-add-button {
    margin-left: 0 !important;
  }
  .receipt-date-filter {
    width: 100%;
  }
  .receipt-mobile-card {
    cursor: pointer;
  }
  .receipt-mobile-details span,
  .receipt-mobile-details strong {
    display: block;
  }
  .receipt-mobile-details span {
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.75rem;
  }
  .receipt-mobile-details strong {
    font-size: 0.9rem;
    overflow-wrap: anywhere;
  }
}
</style>
